<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title61"></a>
<div class="p-c"><span><strong class="b">For Poppy Z. Brite,</strong><br/> <strong class="b">who helps me remember how strange I am</strong></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429910781_ded01.vue?13e2b21b